var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Notification from "./Notification";

export class Notifications extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "alert-wrapper" }, void 0,
      this.props.notifications.map((notification) => /*#__PURE__*/
      React.createElement(Notification, _extends({ key: notification.id }, notification))
      )
      ));

  }
}





const mapStateToProps = (state) => ({ notifications: state.notifications.toJS() });

export default connect(mapStateToProps)(Notifications);